export const IS_SSR = import.meta.env.SSR;
export const ENV = import.meta.env;

// Auto generates routes from vue files under ./pages
// https://vitejs.dev/guide/features.html#glob-import

// 默认异步模式
// eslint-disable-next-line operator-linebreak
export const appPages =
  import.meta.glob('../../src/pages/*.vue');

// 同步模式
// eslint-disable-next-line operator-linebreak
export const syncAppPages =
  {};
